import React from "react";
import { Box, Container, VStack } from "@chakra-ui/react";
import Header from "components/reusables/Header/Header";
import Footer from "components/includes/Footer/Footer";
import UserTransactionsList from "components/userTransaction/UserTransactionsList";

const WalletPage: React.FC = () => {
  //   const dispatch = useAppDispatch();
  //  const navigate = useNavigate();

  // const onBack = () => {
  //   // if (backTo) navigate(backTo);
  //   // else navigate(-1);
  // };

  return (
    <>
      <Header />
      <Box bg="gray.50" pt={{ base: 24, md: 28 }} pb={6}>
        <Container maxW="7xl">
          <VStack gap={1} align="stretch">
            {/* <WalletBalanceCard /> */}
            <UserTransactionsList />
          </VStack>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default WalletPage;

// <>
//   <Header />
//   <Box bg="gray.50"  py={6}>
//     <Container maxW="container.xl" p="30">
//       <Box>
//         <WalletBalanceCard />
//         <WalletTransactionsList />
//       </Box>
//     </Container>
//   </Box>
//   <Footer />
// </>
